import { ImageManipulationPlugin, PluginType, Plugin } from 'editor/src/store/plugins/types';

export default function isImageManipulationPlugin(plugin: Plugin): plugin is ImageManipulationPlugin {
  return plugin.type === PluginType.IMAGE_MANIPULATION;
}
